/* eslint-disable */

// Video Block Controls
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll('.video-block').forEach(function(container) {
    const placeholder = container.querySelector('.video-placeholder');
    const video = container.querySelector('.video-element');
    const playPauseBtn = container.querySelector('.play-pause-btn');
    const playIcon = container.querySelector('.play-icon');
    const pauseIcon = container.querySelector('.pause-icon');
    const muteUnmuteBtn = container.querySelector('.mute-unmute-btn');
    const muteIcon = container.querySelector('.mute-icon');
    const unmuteIcon = container.querySelector('.unmute-icon');

    if (playPauseBtn) {
      playPauseBtn.addEventListener('click', function() {
        if (video.paused) {
          video.play();
          placeholder.style.display = 'none';
          video.style.display = 'block';
          playIcon.style.display = 'none';
          pauseIcon.style.display = 'block';
        } else {
          video.pause();
          playIcon.style.display = 'block';
          pauseIcon.style.display = 'none';
        }
      });
    }

    if (muteUnmuteBtn) {
      muteUnmuteBtn.addEventListener('click', function() {
        if (video.muted) {
          video.muted = false;
          muteIcon.style.display = 'block';
          unmuteIcon.style.display = 'none';
        } else {
          video.muted = true;
          muteIcon.style.display = 'none';
          unmuteIcon.style.display = 'block';
        }
      });
    }
  });
});

/* eslint-enable */



// WEBPACK FOOTER //
// ./scripts/autoload/video-block.js